<script setup lang="ts">
const { wishlist, isLoading, status, error } = useWishlist();
</script>

<template>
  <UiDefaultPage id="my-wishlist" title="Mes favoris">
    <div class="space-y-8">
      <UiQueryWrapper :is-loading="isLoading" :status="status" :error="error">
        <ProductList :products="wishlist.products">
          <template #actions="{ product }">
            <ProductAddToCart :product="product" />
            <ProductToggleWishlist :product-id="product.product_id" :show-label="false" />
          </template>
        </ProductList>
      </UiQueryWrapper>
    </div>
  </UiDefaultPage>
</template>
